// extracted by css-extract-rspack-plugin
export default {"copyright_override":"wpwSZ","copyrightOverride":"wpwSZ","#":"FRjud"};